import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return err?.message || "Something went wrong. Please try again.";
}

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1501276276428-88ec0b385919?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxoaWdod2F5JTIwbGFuZHNjYXBlJTIwc3Vuc2V0JTIwZHJvbmV8ZW58MHx8fHwxNzg4OTU1OTQ3fDA&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/photo-1505843795480-5cfb3c03f6ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlJTIwZHJvbmUlMjBhZXJpYWwlMjB2aWV3fGVufDB8fHx8MTc4ODk1NTk2MXww&ixlib=rb-4.1.0&q=85",
  commercial: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwwfHx8MTc4ODk1NTk0N3ww&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1759310610325-2c7cb621e5e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjByZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBidXNpbmVzcyUyMHRydXN0fGVufDB8fHx8MTc4ODk1NTk0Nnww&ixlib=rb-4.1.0&q=85",
  map: "https://images.unsplash.com/photo-1732006428091-c6ca49c0b418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxoaWdod2F5JTIwbGFuZHNjYXBlJTIwc3Vuc2V0JTIwZHJvbmV8ZW58MHx8fHwxNzg4OTU1OTQ3fDA&ixlib=rb-4.1.0&q=85",
};
